import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

import type { RootState } from "@/store";

export interface worktimesAuditReducerInterface {
  user: Nullable<SmallUser>;
  action: Nullable<AuditActionType>;
  start: Nullable<Date>;
  stop: Nullable<Date>;
}

const initialState: worktimesAuditReducerInterface = {
  user: null,
  action: null,
  start: null,
  stop: null,
};

const worktimesAuditSlice = createSlice({
  name: "worktimes/audit",
  initialState,
  reducers: {
    resetFilters(state) {
      state.user = null;
      state.start = null;
      state.stop = null;
      state.action = null;
    },
    setUser(state, { payload }: PayloadAction<Nullable<SmallUser>>) {
      state.user = payload;
    },
    setAction(state, action: PayloadAction<Nullable<AuditActionType>>) {
      state.action = action.payload;
    },
    setStart(state, { payload }: PayloadAction<Nullable<Date>>) {
      state.start = payload;
    },
    setStop(state, { payload }: PayloadAction<Nullable<Date>>) {
      state.stop = payload;
    },
  },
});

export const { setUser, setAction, setStart, setStop, resetFilters } = worktimesAuditSlice.actions;
export const auditSelector = (state: RootState) => state.worktimesAudit;
export default worktimesAuditSlice.reducer;
